var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 21,
    cy: 21,
    r: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Startsetie-Angemeldet-Men\\xFC",
    transform: "translate(-1316.000000, -36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(81.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy",
    transform: "translate(1237.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,43.35 C33.3435642,43.35 43.35,33.3435642 43.35,21 C43.35,8.65643584 33.3435642,-1.35 21,-1.35 C8.65643584,-1.35 -1.35,8.65643584 -1.35,21 C-1.35,33.3435642 8.65643584,43.35 21,43.35 Z M21,40.65 C10.1476047,40.65 1.35,31.8523953 1.35,21 C1.35,10.1476047 10.1476047,1.35 21,1.35 C31.8523953,1.35 40.65,10.1476047 40.65,21 C40.65,31.8523953 31.8523953,40.65 21,40.65 Z",
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,49.4261421 C28.7514707,49.4261421 35.0352792,43.1423336 35.0352792,35.3908629 C35.0352792,27.6393923 28.7514707,21.3555838 21,21.3555838 C13.2485293,21.3555838 6.96472081,27.6393923 6.96472081,35.3908629 C6.96472081,43.1423336 13.2485293,49.4261421 21,49.4261421 Z M21,46.7261421 C14.7396982,46.7261421 9.66472081,41.6511648 9.66472081,35.3908629 C9.66472081,29.1305611 14.7396982,24.0555838 21,24.0555838 C27.2603018,24.0555838 32.3352792,29.1305611 32.3352792,35.3908629 C32.3352792,41.6511648 27.2603018,46.7261421 21,46.7261421 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21,23.8423858 C25.572329,23.8423858 29.278934,20.1357808 29.278934,15.5634518 C29.278934,10.9911228 25.572329,7.28451777 21,7.28451777 C16.427671,7.28451777 12.721066,10.9911228 12.721066,15.5634518 C12.721066,20.1357808 16.427671,23.8423858 21,23.8423858 Z M21,21.1423858 C17.9188398,21.1423858 15.421066,18.644612 15.421066,15.5634518 C15.421066,12.4822916 17.9188398,9.98451777 21,9.98451777 C24.0811602,9.98451777 26.578934,12.4822916 26.578934,15.5634518 C26.578934,18.644612 24.0811602,21.1423858 21,21.1423858 Z",
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon_account.fdf379777e87a1c9b607e60ea5d26348.svg";
export { ForwardRef as ReactComponent };